import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  CheckCircle,
  Info,
  WarningCircle,
  X,
  XCircle
} from '@phosphor-icons/react';

const Toast = ({ message, type = 'success', isVisible, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const icons = {
    success: <CheckCircle size={20} className="text-[#10B981]" />,
    error: <XCircle size={20} className="text-[#EF4444]" />,
    warning: <WarningCircle size={20} className="text-[#F59E0B]" />,
    info: <Info size={20} className="text-[#3B82F6]" />
  };

  const colors = {
    success: 'bg-[rgba(16,185,129,0.1)] border-[rgba(16,185,129,0.3)]',
    error: 'bg-[rgba(239,68,68,0.1)] border-[rgba(239,68,68,0.3)]',
    warning: 'bg-[rgba(245,158,11,0.1)] border-[rgba(245,158,11,0.3)]',
    info: 'bg-[rgba(59,130,246,0.1)] border-[rgba(59,130,246,0.3)]'
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -50, x: '-50%' }}
          animate={{ opacity: 1, y: 0, x: '-50%' }}
          exit={{ opacity: 0, y: -50, x: '-50%' }}
          className="fixed top-4 left-1/2 z-[100] max-w-md"
        >
          <div className={`glass rounded-xl p-4 border ${colors[type]} flex items-center gap-3 shadow-lg`}>
            {icons[type]}
            <p className="flex-1 text-white text-sm font-medium">{message}</p>
            <button
              onClick={onClose}
              className="text-white/60 hover:text-white transition-colors"
            >
              <X size={18} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;
